import React, { FC } from 'react'

import Badge from '@/modules/components/Badge'
import { BoxProps } from '@/modules/components/Box'
import Button from '@/modules/components/Button'
import Icon from '@/modules/components/Icon'
import Typography from '@/modules/components/Typography'

interface DesktopMenuItemProps extends BoxProps {
  variant: 'dark' | 'light'
  badgeTitle?: string
  chevron?: 'down' | null
  title: string
}

const DesktopMenuItem: FC<DesktopMenuItemProps> = ({
  variant,
  title,
  badgeTitle,
  chevron = 'down',
  ...props
}) => {
  const color = variant === 'dark' ? 'primaryPaleWhite' : 'primaryDeepBlack'

  const renderChevron = () => {
    switch (chevron) {
      case 'down':
        return (
          <Icon.ChevronDown
            className="hoverOpacity"
            fontSize="8px"
            color={color}
            ml="10px"
          />
        )
      default:
        return null
    }
  }
  return (
    <Button
      variant="plain"
      display="flex"
      alignItems="center"
      {...props}
      customCss={{
        '.hoverOpacity': {
          opacity: 0.5,
        },
        '&:hover .hoverOpacity': {
          opacity: 1,
        },
      }}
    >
      <Typography
        className="hoverOpacity"
        variant="h6"
        color={color}
        leadingTrim
      >
        {title}
      </Typography>
      {badgeTitle ? <Badge ml={1}>{badgeTitle}</Badge> : renderChevron()}
    </Button>
  )
}

export default DesktopMenuItem
